import { createAsyncThunk } from '@reduxjs/toolkit';
import { adminSettingService } from '../../services';
import { toast } from 'react-toastify';


const getTriggerFields = createAsyncThunk(
    'adminSettings/getTriggerFields',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getTriggerFields(
                payload.companyId
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updateFields = createAsyncThunk(
    'adminSettings/updateFields',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.updateFields(
                payload.companyId,
                payload.data
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getFlowSettings = createAsyncThunk(
    'adminSettings/getFlowSettings',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getFlowSettings(
                payload.companyId
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updateFlowSetting = createAsyncThunk(
    'adminSettings/updateFlowSetting',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.updateFlowSetting(
                payload.companyId,
                payload.data
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getPartnersChannels = createAsyncThunk(
    'adminSettings/getPartnersChannels',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getPartnersChannels(
                payload.companyId
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getFieldValue = createAsyncThunk(
    'adminSettings/getFieldValue',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getFieldValue(
                payload.companyId,
                payload.partnerId
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updateFieldsValue = createAsyncThunk(
    'adminSettings/updateFieldsValue',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.updateFieldsValue(
                payload.companyId,
                payload.partnerId,
                payload.data
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getChannelTypes = createAsyncThunk(
    'adminSettings/getChannelTypes',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getChannelTypes(
                payload.companyId
            );

            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getAllPartners = createAsyncThunk(
    'adminSettings/getAllPartners',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getAllPartners(
                payload.companyId
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getChannelTypeTemplate = createAsyncThunk(
    'adminSettings/getChannelTypeTemplate',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getChannelTypeTemplate(
                payload.companyId
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const deletePartnersChannel = createAsyncThunk(
    'adminSettings/deletePartnersChannel',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.deletePartnersChannel(
                payload.companyId,
                payload.partnerId,
                payload.id
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteChannel = createAsyncThunk(
    'adminSettings/deleteChannel',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.deleteChannels(
                payload.companyId,
                payload.id
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const saveChannels = createAsyncThunk(
    'adminSettings/saveChannels',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.saveChannels(
                payload.companyId,
                payload.data
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const savePartners = createAsyncThunk(
    'adminSettings/savePartners',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.savePartners(
                payload.companyId,
                payload.data
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getPartnerApi = createAsyncThunk(
    'adminSettings/getPartnerApi',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getPartnerApi(
                payload.companyId
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const deletePartner = createAsyncThunk(
    'adminSettings/deletePartner',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.deletePartner(
                payload.companyId,
                payload.partnerId
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const savePartnerApi = createAsyncThunk(
    'adminSettings/savePartnerApi',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.savePartnerApi(
                payload.companyId,
                payload.partnerId,
                payload.data
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const savePartnerChannels = createAsyncThunk(
    'adminSettings/savePartnerChannels',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.savePartnerChannels(
                payload.companyId,
                payload.partnerId,
                payload.data
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getChannelActions = createAsyncThunk(
    'adminSettings/getChannelActions',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getChannelActions(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error?.response);
        }
    }
);

const getChannelActionById = createAsyncThunk(
    'adminSettings/getChannelActionById',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getChannelActionById(payload.id);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteChannelAction = createAsyncThunk(
    'adminSettings/deleteChannelAction',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.deleteChannelAction(payload.id);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error?.response);
        }
    }
);

const postChannelAction = createAsyncThunk(
    'adminSettings/postChannelAction',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.postChannelAction(payload.data);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const editChannelAction = createAsyncThunk(
    'adminSettings/editChannelAction',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.editChannelAction(payload.data,payload.id);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCacheList = createAsyncThunk(
    'adminSettings/cacheList',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.getCacheList(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error?.response);
        }
    }
);

const clearCache = createAsyncThunk(
    'adminSettings/clearCache',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.clearCache(payload.companyId,payload.data);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error?.response);
        }
    }
);

const clearAllCache = createAsyncThunk(
    'adminSettings/clearAllCache',
    async (payload, ThunkAPI) => {
        try{
            const response = await adminSettingService.clearAllCache(payload.companyId);
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error?.response);
        }
    }
);

export {
    getTriggerFields,
    updateFields,
    getFlowSettings,
    updateFlowSetting,
    getPartnersChannels,
    getFieldValue,
    updateFieldsValue,
    getChannelTypes,
    getAllPartners,
    getChannelTypeTemplate,
    deletePartnersChannel,
    deleteChannel,
    saveChannels,
    savePartners,
    deletePartner,
    getPartnerApi,
    savePartnerApi,
    savePartnerChannels,
    getChannelActions,
    getChannelActionById,
    deleteChannelAction,
    postChannelAction,
    editChannelAction,
    getCacheList,
    clearCache,
    clearAllCache
};